import React from 'react';
import './App.css';
import Main from './main/Main';

function App() {
  return (
    <div className="app">
      <Main />
    </div>
  );
}

export default App;
